import React from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AlarmOff from '@material-ui/icons/AlarmOff';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import TransformIcon from '@material-ui/icons/Transform';
import ReportProblem from '@material-ui/icons/ReportProblem';

const SITUACOES = [
  // Plantões agendados por um gerente e lançados para o profissional
  { id: '10', label: 'Falta', Icone: AlarmOff },
  { id: '11', label: 'Aguardando profissional', Icone: CompareArrowsIcon },
  { id: '12', label: 'Agendado', Icone: AccessTimeIcon },
  { id: '13', label: 'Ocorrendo', Icone: AvTimerIcon },
  { id: '14', label: 'Realizado', Icone: DoneAllIcon },
  { id: '15', label: 'Solicitação recusada', Icone: NotInterestedIcon },
  { id: '17', label: 'Aguardando aprovação', Icone: AccessTimeIcon },
  { id: '18', label: 'Cancelado', Icone: DoneAllIcon },
  { id: '19', label: 'Atrasado', Icone: ReportProblem },

  // Plantões enviados para um colega
  {
    id: '21',
    label: 'Encaminhado',
    Icone: CompareArrowsIcon,
    rotulo: ({ novo }) => novo?.name && `Encaminhado para ${novo.name}`,
  },
  { id: '22', label: 'Enviado e Confirmado', Icone: TransformIcon },
  { id: '23', label: 'Enviado e Recusado', Icone: NotInterestedIcon },

  // Plantões recebidos de um colega na unidade
  {
    id: '31',
    label: 'Recebido',
    Icone: CompareArrowsIcon,
    rotulo: ({ anterior }) => anterior?.name && `Recebido de ${anterior.name}`,
  },
  {
    id: '32',
    label: 'Recebido e Aceito',
    Icone: TransformIcon,
    rotulo: ({ anterior }) =>
      anterior?.name && `Recebido de ${anterior.name} e Aceito`,
  },
  { id: '33', label: 'Recebido e em Andamento', Icone: AccessTimeIcon },
  { id: '34', label: 'Recebido e Realizado', Icone: DoneAllIcon },
  { id: '35', label: 'Recebido e Recusado', Icone: NotInterestedIcon },
  { id: '38', label: 'Recebido e Cancelado', Icone: NotInterestedIcon },
];

export const StatusSituationType = (classes, userAnterior, userNovo) =>
  SITUACOES.map(({ id, label, Icone, rotulo }) => ({
    id,
    label:
      (rotulo && rotulo({ anterior: userAnterior, novo: userNovo })) || label,
    icon: <Icone className={classes.icon} />,
  }));
